import {
  faExclamationTriangle,
  faUserCheck
} from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconAlert from 'components/common/IconAlert';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  addUserOathStatement,
  refreshUserMasterDetails,
  refreshUserOathStatement,
  updateUserMaster,
  updateUserOathStatement
} from 'stores/app';
import logger from 'util/logger';

const ProfileOathStatement = props => {
  const { userMaster } = useSelector(state => state.app);
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [oathStatement, setOathStatement] = useState(null);
  const [showOathStatement, setShowOathStatement] = useState(false);

  const [formData, setFormData] = useState({
    GUID: null,
    Statement: ''
  });

  useEffect(() => {
    setLoading(true);
    dispatch(refreshUserMasterDetails(userMaster.GUID))
      .then(res => {
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (userMaster?.OathStatement) {
      setOathStatement(userMaster?.OathStatement);
      setFormData({
        ...formData,
        GUID: userMaster?.OathStatement,
        Statement: userMaster?.OathStatement
      });
    }
  }, [userMaster?.OathStatement]);

  const save = () => {
    setSaving(true);
    dispatch(
      updateUserMaster(userMaster.GUID, { OathStatement: formData.Statement })
    )
      .then(res => {
        setSaving(false);
        toast.success(`Oath Statement saved successfully`, {
          theme: 'colored',
          position: 'bottom-center',
          icon: faUserCheck,
          toastId: 'login-success'
        });
        dispatch(refreshUserMasterDetails());
        setShowOathStatement(false);
      })
      .catch(err => {
        logger.log('err', err);
        setSaving(false);
        toast.error(`Unable to save Oath Statement. Try again`, {
          theme: 'colored',
          position: 'bottom-center',
          icon: faExclamationTriangle,
          toastId: 'login-success'
        });
      });
  };

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
  };

  return (
    <Card {...props}>
      <FalconCardHeader title="Oath Statement" />
      <Card.Body className="bg-light">
        <IconAlert variant={'info'}>
          <h5>What is the difference between an oath and an affirmation?</h5>
          <p className="mb-0">
            Both are notarial acts that compel a person to be truthful. An oath
            is a solemn, spoken pledge to God or a Supreme Being, while an
            affirmation is a spoken pledge made on the signer's personal honor
            with no reference to a higher power. Either is considered
            acceptable, and the choice must be left to the signer.
          </p>
        </IconAlert>
        {showOathStatement && (
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3 g-3">
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="intro">
                  {/* <Form.Label>Intro</Form.Label> */}
                  <Form.Control
                    as="textarea"
                    rows={16}
                    placeholder="Write Oath statement..."
                    value={formData.Statement}
                    name="Statement"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col sm={12} className="text-center">
                <Button
                  className="mx-1"
                  variant="primary"
                  type="submit"
                  disabled={saving || formData.Statement == oathStatement}
                  onClick={() => save()}
                >
                  {saving ? <Spinner size="sm" variant="light" /> : 'Update'}
                </Button>
                <Button
                  className="mx-1"
                  variant="danger"
                  type="button"
                  disabled={saving}
                  onClick={() => setShowOathStatement(false)}
                >
                  Close
                </Button>
              </Col>
            </Row>
            {saving && (
              <Row>
                <Col
                  sm={12}
                  as={Flex}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Spinner size="sm" variant="primary" /> &nbsp; Saving...
                </Col>
              </Row>
            )}
          </Form>
        )}
        {!showOathStatement && (
          <>
            {loading ? (
              <Flex
                justifyContent={'justify'}
                direction="column"
                alignContent="center"
                alignItems="center"
                className="text-center my-3 py-3"
              >
                <Spinner />
                <p className="mt-3 text-muted">Loading profile OathStatement</p>
              </Flex>
            ) : (
              <Col sm={12} md={12} className="pe-lg-2 mb-3">
                <Row>
                  <Col sm={12} className="my-3">
                    <Card>
                      <Card.Header>
                        <Flex style={{ justifyContent: 'space-between' }}>
                          <div>Oath Statement</div>
                          <div>
                            <Button
                              variant="primary"
                              onClick={() => setShowOathStatement(true)}
                            >
                              Edit
                            </Button>
                          </div>
                        </Flex>
                      </Card.Header>
                      <Card.Body className="pt-0">
                        <p style={{ whiteSpace: 'pre-line' }}>
                          {oathStatement ||
                            "Click 'Edit' button to add or change your oath statement"}
                        </p>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default ProfileOathStatement;
